<template>
  <div class="region-wrap">
    <van-popup :value="visible" round :close-on-click-overlay="false" position="bottom">
      <div class="region">
        <div class="region-title border-bottom">购买项目的机构</div>
        <div class="region-content">
          <ul class="region-list">
            <li v-for="item in region.regionList" :key="item.id" @click="handleSelectRegion(item)">{{ item.orgName }}</li>
          </ul>
        </div>
        <div class="region-footer">
          <div class="add-region border-bottom" @click="region.showAddRegion = true">添加机构</div>
          <van-button size="small" @click="$emit('update:visible', false)">取 消</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 添加机构 -->
    <AddRegion v-if="region.showAddRegion" :visible.sync="region.showAddRegion" @saveRegion="handleAddRegion" />
  </div>
</template>

<script>
import { createCustomerRegion, getCustomerRegionList } from '@/api/customer'
import AddRegion from './index'
export default {
  name: 'SelectRegion',
  components: { AddRegion },
  props: {
    visible: {
      type: Boolean,
      require: true
    },
    customerId: {
      type: Number,
      require: true
    }
  },
  data() {
    return {
      region: {
        showAddRegion: false,
        regionList: []
      }
    }
  },
  watch: {
    customerId(newVal) {
      this.getCustomerRegionList({ customerId: newVal, page: 1, count: 2000 })
    }
  },
  methods: {
    /**
     * 添加机构
     */
    handleAddRegion(params) {
      const { customerId } = this
      createCustomerRegion({ ...params, customerId }).then((res) => {
        if (res.errcode === 0) {
          this.$toast.success('新增用户机构成功')
          this.getCustomerRegionList({ customerId, page: 1, count: 2000 })
          this.$emit('addRegionSuccess')
          this.$emit('update:visible', false)
        }
      });
    },
    // 获取用户机构列表
    getCustomerRegionList(params) {
      getCustomerRegionList(params).then((res) => {
        if (res.errcode === 0) {
          this.region.regionList = res.data
        }
      })
    },
    handleSelectRegion(item) {
      console.log(item, 'item');
    }
  }
}
</script>

<style lang="less" scoped>
.region-wrap {
  .region { color: #333;
    &-title { text-align: center; padding: 10px 0; font-size: 14px; }
    &-content {
      text-align: center; max-height: calc(~'40vh - 80px'); overflow-y: auto;
      .region-list { position: relative; max-height: calc(~'100% - 124px'); overflow-y: auto;
        &::before {
          content: '';
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
          border-top: 1px solid #ebedf0;
          transform: scaleY(.5);
        }
        li { padding: 10px 0; font-size: 12px; position: relative;
          &:not(:first-child) {
            &::after {
              content: '';
              position: absolute;
              width: 100%;
              top: 0;
              left: 0;
              border-top: 1px solid #ebedf0;
              transform: scaleY(.5);
            }
          }
        }
      }
    }
    &-footer { padding: 5px 0;
      .add-region { padding: 5px 0 10px; text-align: center; font-size: 14px; color: #0000ffc4; }
      .van-button { width: 100%; border: none; padding-top: 10px; }
    }
  }
}
</style>